module.exports = __webpack_public_path__ + "static/futur-call-hero-en-7f0ff751f46e7ff3f16ac9840624be69.jpg";